import { render, staticRenderFns } from "./ReviewSoftwareForms.vue?vue&type=template&id=669359c4"
import script from "./ReviewSoftwareForms.vue?vue&type=script&lang=js"
export * from "./ReviewSoftwareForms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports